import "../../../../content/departments/media/influence.css";
import * as React from 'react';
export default {
  React
};